<template>
  <section v-bind="$attrs">
    <Article
      v-for="(article, index) in articles"
      v-bind:key="article.path"
      v-bind:article="article"
      v-bind:index="index"
      @view-article="$emit('view-article', $event)"
    />
  </section>
  <section class="tw-flex tw-justify-center tw-items-center">
    <div class="tw-flex tw-text-[#b5b5b9] tw-gap-3 md:tw-gap-6 lg:tw-gap-8 xl:tw-gap-10 2xl:tw-gap-14">
      <button
        class="tw-flex tw-justify-center tw-items-center"
        :class="{
          'tw-text-black tw-cursor-pointer': page !== 1,
        }"
        :disabled="page === 1"
        @click="page = page-1"
      >
        <SvgoCommonArrowWhite class="tw-w-4 tw-h-4 tw-rotate-180" />
        <span class="tw-font-semibold tw-tracking-normal tw-text-xl">BACK</span>
      </button>
      <div class="tw-flex tw-gap-3">
        <template v-for="item in $pages">
          <a
            class="tw-flex tw-justify-center tw-items-center tw-cursor-pointer"
            :class="{
              'tw-text-black': item.active,
            }"
            v-if="item"
            @click="page = item.page"
            >{{ item.page }}</a
          >
          <span class="tw-btn btn-disabled" v-else>...</span>
        </template>
      </div>

      <button
        class="tw-flex tw-justify-center tw-items-center tw-cursor-pointer"
        :class="{
          'tw-text-black tw-cursor-pointer': length !== page,
        }"
        :disabled="length === page"
        @click="page = page + 1"
      >
        <span class="tw-font-semibold tw-tracking-normal tw-text-xl">NEXT</span>
        <SvgoCommonArrowWhite class="tw-w-4 tw-h-4" />
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
  import Article from './Article.vue'
  import { getQueryParams } from './utils'

  const props = defineProps({
    limit: {
      type: Number,
      default: 0,
    },
  })

  const page = ref(1)

  const skip = computed(() => (page.value - 1) * props.limit)

  // 获取文章列表
  const { data: allArticles } = await useAsyncData(
    'repost-feed-all-articles',
    async () => {
      try {
        console.log('开始查询文章...')
        
        // 查询所有文章
        const all = await queryCollection('articles').all()
        
        console.log('查询结果:', all)
        console.log('文章数量:', all?.length || 0)
        
        if (!all || all.length === 0) {
          console.warn('未找到任何文章')
          return []
        }
        
        const now = new Date()
        
        // 过滤草稿和未到发布时间的文章
        const filtered = all.filter((article: any) => {
          // 过滤草稿
          if (article.draft === true) {
            console.log('过滤草稿:', article.title)
            return false
          }
          
          // 过滤未到发布时间的文章
          if (article.schedule) {
            const scheduleDate = new Date(article.schedule)
            if (scheduleDate > now) {
              console.log('过滤未发布文章:', article.title, scheduleDate)
              return false
            }
          }
          
          return true
        })
        
        // 按日期降序排序
        const sorted = filtered.sort((a: any, b: any) => {
          const dateA = a.date ? new Date(a.date).getTime() : 0
          const dateB = b.date ? new Date(b.date).getTime() : 0
          return dateB - dateA
        })
        
        console.log('过滤排序后的文章数量:', sorted.length)
        console.log('文章列表:', sorted)
        return sorted
      } catch (error) {
        console.error('Failed to fetch articles:', error)
        console.error('错误详情:', error)
        return []
      }
    }
  )

  const articles = computed(() => {
    console.log(allArticles.value)
    if (!allArticles.value) return []
    const start = skip.value
    const end = start + props.limit
    return allArticles.value.slice(start, end)
  })

  // 获取文章总数
  const count = computed(() => allArticles.value?.length || 0)

  const length = computed(() => {
    if (count.value) {
      return Math.ceil(count.value / props.limit)
    } else {
      return 0
    }
  })

  const $pages = computed(() => {
    const pageItems = []
    const $totalPage = length.value
    const $page = page.value

    if ($totalPage > 5) {
      if ($page <= 4) {
        for (let i = 0; i < 5; i++) {
          if (i + 1 == $page) {
            pageItems.push({ page: i + 1, active: true })
          } else {
            pageItems.push({ page: i + 1 })
          }
        }
        pageItems.push(null)
        pageItems.push({ page: $totalPage })
      } else if ($page > 4 && $page < $totalPage - 3) {
        pageItems.push({ page: 1 })
        pageItems.push(null)
        for (let i = $page - 3; i < $page + 2; i++) {
          if (i + 1 == $page) {
            pageItems.push({ page: i + 1, active: true })
          } else {
            pageItems.push({ page: i + 1 })
          }
        }
        pageItems.push(null)
        pageItems.push({ page: $totalPage })
      } else if ($page >= $totalPage - 3) {
        pageItems.push({ page: 1 })
        pageItems.push(null)
        for (let i = $totalPage - 5; i < $totalPage; i++) {
          if (i + 1 == $page) {
            pageItems.push({ page: i + 1, active: true })
          } else {
            pageItems.push({ page: i + 1 })
          }
        }
      }
    } else {
      for (let i = 0; i < $totalPage; i++) {
        if (i + 1 == $page) {
          pageItems.push({ page: i + 1, active: true })
        } else {
          pageItems.push({ page: i + 1 })
        }
      }
    }
    return pageItems
  })
</script>

<style scoped></style>
